module.exports = require("./ProjectPicker.vue");